exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fadein i{position:absolute;font-size:200px;opacity:0;transform:translateX(-50%);animation-name:fade;animation-duration:28s;animation-iteration-count:infinite}@keyframes fade{0%{opacity:0}7.14286%{opacity:1}25%{opacity:1}32.14286%{opacity:0}to{opacity:0}}.fadein i:first-child{animation-delay:.1s}.fadein i:nth-child(2){animation-delay:7.1s}.fadein i:nth-child(3){animation-delay:14.1s}.fadein i:nth-child(4){animation-delay:21.1s}.fadein{width:100%;height:200px;position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d3cb93a0","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/content/latest-page.vue
// module id = 405
// module chunks = 0